<template>
  <div class="im-input-number text-black" :class="[size, disabled ? 'is-disabled' : '']">
    <div class="btn" :class="{ 'disabled': prevDisabled }" @click="handleSub">
      <i class="el-icon-minus" />
    </div>
    <el-input v-model="data" class="number" @change="onChange"/>
    <div class="btn" :class="{ 'disabled': nextDisabled }" @click="handleAdd">
      <i class="el-icon-plus" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImInputNumber',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    number: {
      type: Number,
      default: 0
    },
    min: {
      type: Number,
      default: 1
    },
    size: {
      type: String,
      default: 'small'
    },
    max: {
      type: Number,
      default: 999
    }
  },
  data() {
    return {
      data: this.number
    }
  },
  computed: {
    nextDisabled() {
      return this.number >= this.max
    },
    prevDisabled() {
      return this.number <= this.min
    }
  },
  watch: {
    number(val) {
      console.log(val, 1221)
      this.data = val
    }
  },
  methods: {
    handleSub() {
      if (this.prevDisabled) return
      this.$emit('change', this.number - 1)
    },
    handleAdd() {
      if (this.nextDisabled) return
      this.$emit('change', this.number + 1)
    },
    onChange(value) {
      this.$emit('change', value)
    }
  }
}
</script>

<style lang="less">
.im-input-number {
  display: flex;
  align-items: center;
  border: 1px solid @border-color-1;
  border-radius: 2px;
  .number {
    .el-input__inner {
      border: 0;
      padding: 0;
      text-align: center;
    }
  }
  &.is-disabled {
    opacity: 0.3;
    pointer-events: none;
  }
  &.small {
    width: 130px;
    .btn {
      width: 37px;
      height: 36px;
    }
  }
  &.mini {
    width: 86px;
    .btn {
      width: 26px;
      height: 26px;
    }
    .number {
      font-size: 12px;
    }
  }
  .btn {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-weight: bold;
    &:first-of-type {
      border-right: 1px solid @border-color-1;
    }
    &:last-of-type {
      border-left: 1px solid @border-color-1;
    }
    &:hover {
      background-color: @border-color-1;
    }
    &.disabled {
      color: @text-3-hex;
      cursor: not-allowed;
      &:hover {
        background-color: unset;
      }
    }
  }
  .number {
    flex: 1;
    text-align: center;
  }
}
</style>
